import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const MoneyIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      d="M11.0001 18.9996C15.4184 18.9996 19.0001 15.4179 19.0001 10.9996C19.0001 6.58129 15.4184 2.99957 11.0001 2.99957C6.58184 2.99957 3.00012 6.58129 3.00012 10.9996C3.00012 15.4179 6.58184 18.9996 11.0001 18.9996Z"
      stroke="#183558"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.12448 2.99957C8.94894 2.99957 8.7765 3.04578 8.62448 3.13355L5.37577 5.00919C5.22375 5.09696 5.09751 5.2232 5.00974 5.37522L3.1341 8.62393C3.04633 8.77595 3.00012 8.94839 3.00012 9.12393V12.8752C3.00012 13.0508 3.04633 13.2232 3.1341 13.3752L5.00974 16.6239C5.09751 16.7759 5.22375 16.9022 5.37577 16.99L8.62448 18.8656C8.7765 18.9534 8.94894 18.9996 9.12448 18.9996H12.8758C13.0513 18.9996 13.2237 18.9534 13.3758 18.8656L16.6245 16.99C16.7765 16.9022 16.9027 16.7759 16.9905 16.6239L18.8661 13.3752C18.9539 13.2232 19.0001 13.0508 19.0001 12.8752V9.12393C19.0001 8.94839 18.9539 8.77595 18.8661 8.62393L16.9905 5.37522C16.9027 5.2232 16.7765 5.09696 16.6245 5.00919L13.3758 3.13355C13.2237 3.04578 13.0513 2.99957 12.8758 2.99957H9.12448ZM8.11787 2.17472C8.46296 2.26718 8.83117 2.16852 9.0838 1.9159L10.293 0.706679C10.6835 0.316155 11.3167 0.316155 11.7072 0.70668L12.9164 1.9159C13.1691 2.16852 13.5373 2.26718 13.8824 2.17472L15.5342 1.73211C16.0677 1.58917 16.616 1.90575 16.7589 2.43922L17.2015 4.09104C17.294 4.43613 17.5636 4.70568 17.9087 4.79815L19.5605 5.24075C20.0939 5.3837 20.4105 5.93203 20.2676 6.4655L19.825 8.11732C19.7325 8.46241 19.8312 8.83062 20.0838 9.08325L21.293 10.2925C21.6835 10.683 21.6835 11.3162 21.293 11.7067L20.0838 12.9159C19.8312 13.1685 19.7325 13.5367 19.825 13.8818L20.2676 15.5336C20.4105 16.0671 20.0939 16.6154 19.5605 16.7584L17.9087 17.201C17.5636 17.2935 17.294 17.563 17.2015 17.9081L16.7589 19.5599C16.616 20.0934 16.0677 20.41 15.5342 20.267L13.8824 19.8244C13.5373 19.732 13.1691 19.8306 12.9164 20.0832L11.7072 21.2925C11.3167 21.683 10.6835 21.683 10.293 21.2925L9.0838 20.0832C8.83117 19.8306 8.46296 19.732 8.11787 19.8244L6.46605 20.267C5.93258 20.41 5.38424 20.0934 5.2413 19.5599L4.7987 17.9081C4.70623 17.563 4.43668 17.2935 4.09159 17.201L2.43977 16.7584C1.9063 16.6154 1.58972 16.0671 1.73266 15.5336L2.17527 13.8818C2.26773 13.5367 2.16907 13.1685 1.91645 12.9159L0.707228 11.7067C0.316704 11.3162 0.316705 10.683 0.707229 10.2925L1.91645 9.08325C2.16907 8.83062 2.26773 8.46241 2.17527 8.11732L1.73266 6.4655C1.58972 5.93203 1.9063 5.3837 2.43977 5.24075L4.09159 4.79815C4.43668 4.70568 4.70623 4.43613 4.7987 4.09104L5.2413 2.43922C5.38424 1.90575 5.93258 1.58917 6.46605 1.73211L8.11787 2.17472Z"
      fill="#183558"
    />
    <path
      d="M8.16988 14.5301C8.06445 14.426 7.83251 14.0094 8.16988 13.4262C8.50725 12.8429 9.00276 12.9783 9.12927 13.0721C9.48773 13.3116 10.1308 13.7594 10.9216 13.7594C11.4276 13.7594 11.7966 13.447 11.7966 13.0096C11.7966 12.4888 11.3327 12.1451 10.4893 11.7494C9.27687 11.1557 8.04336 10.4892 8.04336 8.98948C8.04336 7.75013 9.02385 6.50037 10.9637 6.50037C12.2816 6.50037 13.2937 7.16691 13.6732 7.43769C13.8208 7.52101 13.726 8.10423 13.494 8.41667C13.2621 8.72912 12.7982 9.03114 12.5452 8.88534C12.2605 8.68746 11.512 8.20838 10.8372 8.20838C10.3101 8.20838 10.0676 8.53124 10.0676 8.89575C10.0676 9.31234 10.5631 9.6352 11.4487 10.0622C12.5662 10.6038 14.0001 11.2078 14.0001 12.9054C14.0001 14.1968 12.872 15.4883 11.0164 15.4883C9.37176 15.4987 8.46508 14.8217 8.16988 14.5301Z"
      fill="#183558"
    />
    <rect
      x="10.2521"
      y="5.00067"
      width="1.49972"
      height="2.99944"
      rx="0.749859"
      fill="#183558"
    />
    <rect
      x="10.2521"
      y="13.999"
      width="1.49972"
      height="2.99944"
      rx="0.749859"
      fill="#183558"
    />
  </svg>
));

export default MoneyIcon;
